import { useEffect } from "react"
import { useQueryClient } from "@tanstack/react-query"
import { useAuth } from "@/context/AuthContext"
import {
  connectTournamentSocket,
  emitTournamentEvent,
  onTournamentEvent,
} from "@/socket/tournamentSocket"

export function useTournamentLive(
  tournamentId: string | undefined,
  queryKey: unknown[]
) {
  const { token } = useAuth()
  const queryClient = useQueryClient()

  useEffect(() => {
    if (!tournamentId || !token) return

    let cancelled = false
    const cleanups: (() => void)[] = []

    void connectTournamentSocket(token)
      .then(() => {
        if (cancelled) return
        emitTournamentEvent("join-tournament", { tournamentId })
        cleanups.push(
          onTournamentEvent("tournament-updated", () => {
            void queryClient.invalidateQueries({ queryKey })
          })
        )
        cleanups.push(
          onTournamentEvent("match-updated", () => {
            void queryClient.invalidateQueries({ queryKey })
          })
        )
        cleanups.push(
          onTournamentEvent("tournament-joined", () => {
            void queryClient.invalidateQueries({ queryKey })
          })
        )
      })
      .catch(() => {})

    return () => {
      cancelled = true
      cleanups.forEach((fn) => fn())
    }
  }, [tournamentId, token, queryClient, queryKey[0]])
}
